module.exports = __webpack_public_path__ + "assets/61b2072ee884f60576c510a618e1d787.png";